module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.attribute.sorteditAble === false) ? _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label",
    staticStyle: {
      "width": "60%",
      "color": "#8e8e93"
    }
  }, [_vm._v(_vm._s(this.attribute.label))]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    staticClass: "open-popup open-goods",
    attrs: {
      "type": "text",
      "disabled": "disabled",
      "placeholder": "选基因",
      "data-popup": ".popup-gene-only",
      "readonly": "",
      "unselectable": "on"
    },
    domProps: {
      "value": _vm.attribute.valueText
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label",
    staticStyle: {
      "width": "60%",
      "color": "#8e8e93"
    }
  }, [_vm._v("基因大小")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.curAttrsInGroup[10].valueText
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label",
    staticStyle: {
      "width": "60%",
      "color": "#8e8e93"
    }
  }, [_vm._v("转录本")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.curAttrsInGroup[8].valueText
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label",
    staticStyle: {
      "width": "60%",
      "color": "#8e8e93"
    }
  }, [_vm._v("物种")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.curAttrsInGroup[9].valueText
    }
  })])])]) : _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label",
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v(_vm._s(this.attribute.label))]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    staticClass: "open-popup open-goods",
    attrs: {
      "type": "text",
      "placeholder": "选基因",
      "data-popup": ".popup-gene-only",
      "readonly": "",
      "unselectable": "on"
    },
    domProps: {
      "value": _vm.attribute.valueText
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label",
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v("基因大小")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.curAttrsInGroup[10].valueText
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label",
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v("转录本")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.curAttrsInGroup[8].valueText
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label",
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v("物种")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.curAttrsInGroup[9].valueText
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4da19f80","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./script/loaders/emktVueLoader.js!./src/views/Cust/AttrGeneBox.vue
// module id = 1628
// module chunks = 8